import { Avatar, AvatarFallback, AvatarImage } from '@parentsquare/squarekit/components/ui/avatar';
import { BOT_INITIALS, type AvatarType } from '@/Public/ChatBot/Constants';

export const renderAvatar = (
    avatarType: AvatarType,
    initials: string,
    avatarImageUrl: string | undefined,
    _assistantName: string,
    size: 'md' | 'sm',
): React.ReactElement => {
    const avatarKey = `${avatarType}-${avatarImageUrl ?? 'none'}-${size}`;

    if (avatarType === 'image' && avatarImageUrl) {
        return (
            <Avatar
                key={avatarKey}
                version="v1"
                size={size}
            >
                <AvatarImage
                    src={avatarImageUrl}
                    alt=""
                />
                <AvatarFallback
                    version="v1"
                    variant="initials"
                >
                    {initials}
                </AvatarFallback>
            </Avatar>
        );
    }
    if (avatarType === 'initials') {
        return (
            <Avatar
                key={avatarKey}
                version="v1"
                size={size}
                aria-hidden="true"
            >
                <AvatarFallback
                    version="v1"
                    variant="initials"
                >
                    {initials}
                </AvatarFallback>
            </Avatar>
        );
    }
    return (
        <Avatar
            key={avatarKey}
            version="v1"
            size={size}
            aria-hidden="true"
        >
            <AvatarFallback
                version="v1"
                variant="initials"
            >
                {BOT_INITIALS}
            </AvatarFallback>
        </Avatar>
    );
};
